import { createFileRoute, redirect } from "@tanstack/react-router";

// Old /organizations links (sent emails, bookmarks) must keep resolving after DEV-681.
export const Route = createFileRoute("/_authed/$companySlug/organizations/")({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/$companySlug/organisations",
      params,
      search,
      replace: true,
    });
  },
});
